/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Text, theme } from "@nordcloud/gnui";

type Props = { title: string };

export function KpiSectionTitle({ title }: Props) {
  return (
    <FlexContainer alignContent="center">
      <Text nowrap weight="medium" mb={0} mr={theme.spacing.spacing02}>
        {title}
      </Text>
    </FlexContainer>
  );
}
